import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import DataContext from '../../Context';
import { IPolicy } from '../../Models/PolicyInfo';
import './GetStarted.css';
import Button from '../../Components/Button';
import ButtonGroup from '../../Components/ButtonGroup';
import Checkbox from '../../Components/Checkbox';
import './GetStarted.css';
import '../../Components/FEIN/Fein.css';
import FormRow from '../../Components/FormRow';
import { API_ACTION, SaifFetch } from '../../Utils/SaifFetch';
import useSaifFetch from '../../hooks/useSaifFetch';
import { LoadingSpinner } from '@saif/loading-spinner';
import NumericInput from '../../Components/NumericInput';
import Label from '../../Components/Label';
import TextInput from '../../Components/TextInput';
import ValidationError from '../../Components/ValidationError';
import LocalizationContext from '../../Localization/LanguageContext';
import { ILocalizationContext } from '../../Localization/Models/ILocalizationContext';

const GetStarted = () => {
  const {
    guid,
    setGuid,
    guidError,
    setGuidError,
    setFirstName,
    setLastName,
    certified,
    setCertified,
    haveClaim,
    setHaveClaim,
    setFein,
    setSecurityQuestions,
    setPermCertificates,
    setPermPolicyClaim,
    setPermUMView,
    setPermUMFullAccess,
    setPermPolicyAdmin,
    setPermReportPay,
    policy,
    setPolicy,
    email,
    setEmail,
    setErrorPageMsg,
    checkingData,
    setCheckingData,
    validKey,
    setValidKey,
    setJwtToken,
  } = useContext(DataContext) as IPolicy;

  const { getValue, setLocale } = useContext(
    LocalizationContext
  ) as ILocalizationContext;

  let navigator = useNavigate();
  let [searchParams] = useSearchParams();

  const [policyNumRequired, setPoReq] = useState<boolean>(false);
  const [emailRequired, setEmReq] = useState<boolean>(false);
  const [certReq, setCertReq] = useState<boolean>(true);
  const [dataFail, setDataFil] = useState<boolean>(false);

  const [shouldCallValidate, callValidate] = useState({});
  const [shouldGetSecurityQuestions, getSecurityQuestions] = useState({});
  const [body, setBody] = useState({});
  const {
    data: validateData,
    loading: validateLoading,
    status: validateStatus,
    error: validateError,
  } = useSaifFetch<any>(
    API_ACTION.Validate_UID + searchParams.get('id'),
    shouldCallValidate,
    SaifFetch.get
  );
  const { data: securityQuestionData, status: securityQuestionStatus } =
    useSaifFetch<any>(
      API_ACTION.SecurityQuestions,
      shouldGetSecurityQuestions,
      SaifFetch.get
    );
  const {
    data: validateInfo,
    loading: validateInfoLoading,
    status: validateInfoStatus,
    error: validateInfoError,
  } = useSaifFetch<any>(API_ACTION.Validate_User, body, SaifFetch.post);

  const GoNext = () => {
    if (IsDataValid()) {
      setBody({
        email: email,
        Policy: parseInt(policy),
        Uid: guid,
      });
    } else {
      setCertReq(false);
      POblur();
      EmailBlur();
      setTimeout(handleErrorCheck, 10);
    }
  };

  useEffect(() => {
    var lan = localStorage.getItem('SAIFLanguage');
    if (lan == 'es') {
      setLocale('es');
    }
  });

  useEffect(() => {
    if (validateInfoStatus === 200) {
      setFirstName(validateInfo['firstName']);
      setLastName(validateInfo['lastName']);
      setEmail(validateInfo['email']);
      navigator('/PolicyInfo', { replace: true });
    } else if (validateInfoStatus && validateInfoStatus === 400) {
      setDataFil(true);
    } else if (
      (validateInfoStatus && validateInfoStatus >= 401) ||
      validateInfoError
    ) {
      setErrorPageMsg('');
      navigator('/error');
    }
  }, [validateInfoStatus, validateInfoError]);

  useEffect(() => {
    try {
      if (!guid) {
        if (searchParams.get('id')?.length !== 32) {
          setCheckingData(false);
          navigator('/invalid');
        } else {
          //validateGuid(searchParams.get("id"));
          callValidate({ default: true });
        }
      }
    } catch {
      navigator('/invalid');
    }
  }, []);

  useEffect(() => {
    // Read language from response, set default language accordingly

    if (validateData && validateData['language'])
      setLocale(validateData['language'].toString() === 'es' ? 'es' : 'en');

    if (validateStatus === 200) {
      setGuid(searchParams.get('id') as string);
      setFein(validateData['fein']);
      setJwtToken(validateData['token']);
      getSecurityQuestions({ default: true });
      setCheckingData(false); // Turn off the smile spinner.
      setValidKey(true); // daniel was here.
      var listPermissionsToApply = validateData[
        'permissionsToApply'
      ] as string[];
      if (listPermissionsToApply.length > 0) {
        listPermissionsToApply.forEach(
          (x, index, listPerms) => (listPerms[index] = x.toLowerCase())
        );
        setPermCertificates(listPermissionsToApply.includes('certificates'));
        setPermPolicyClaim(listPermissionsToApply.includes('claimsaccess'));
        setPermReportPay(listPermissionsToApply.includes('payrollreports'));
        setPermUMView(
          listPermissionsToApply.includes('usermanagementviewaccess')
        );
        setPermUMFullAccess(
          listPermissionsToApply.includes('usermanagementfullaccess')
        );
        setPermPolicyAdmin(
          listPermissionsToApply.includes('policyholderadmin')
        );
      }
    } else if (validateStatus === 400) {
      setGuidError('Matching Guid Not Found!');
      if ('denied' in validateData) navigator('/denied');
      else navigator('/invalid');
    } else if ((validateStatus && validateStatus >= 401) || validateError) {
      setErrorPageMsg('');
      navigator('/error');
    }
  }, [validateStatus, validateError]);

  useEffect(() => {
    if (securityQuestionStatus === 200) {
      setSecurityQuestions(securityQuestionData);
    } else if (securityQuestionStatus === 400) {
      console.log('Failed to fetch security questions');
    }
  }, [securityQuestionStatus]);

  let IsDataValid = () => {
    if (certified && isValidPolicyNum(policy) && emailTest(email)) return true;
    return false;
  };

  const NumbersOnly = (testval: string) => {
    if (testval.match(/^[0-9]*$/) && testval.length <= 10) {
      setPolicy(testval);
    }
  };

  const isValidPolicyNum = (testval: string): boolean => {
    if (testval.length < 4 || testval.length > 10) return false;
    for (let i = 0; i < testval.length; i++) {
      let c = testval[i];
      if (c < '0' || c > '9') {
        return false;
      }
    }
    return true;
  };

  const POblur = () => {
    if (!policy || policy.length < 4) setPoReq(true);
  };
  const POfocus = () => {
    setPoReq(false);
  };
  const EmailFocus = () => {
    setEmReq(false);
  };

  const emailTest = (testval: string): boolean => {
    var pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/i);

    return pattern.test(testval);
  };

  const EmailBlur = () => {
    if (!email) setEmReq(true);
    if (!emailTest(email)) setEmReq(true);
  };

  const handleChangeCertified = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCertified(e.target.checked);
    if (e.target.checked) setCertReq(false);
  };
  const handleChangeClaim = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHaveClaim(e.target.checked);
  };
  const handleErrorCheck = () => {
    const input = document.querySelector(`.input-error,.check-error`);

    input?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  };
  // const validateGuid = async (id: string | null) => {
  //   await SaifFetch.get(
  //     API_ACTION.Validate_UID + searchParams.get("id")
  //   ).then((result) => {
  //     if (result && result.validKey == true) {
  //       console.log("setting FEIN");
  //       setFein(result.fein);
  //     }
  //     else {
  //       setGuidError("Matching Guid Not Found!");
  //     }
  //     sessionStorage.setItem("jwtToken", result.token);
  //   });
  // };

  return (
    <>
      {checkingData ? (
        <LoadingSpinner
          className="loading"
        />
      ) : (
        <div className='container form-container bg-white mt-5 mb-4 px-4 rounded-3 shadow'>
          {validateInfoLoading && (
            <div className='loading position-fixed'>
              <div className='d-flex justify-content-center loading'>
                <LoadingSpinner text={getValue('GetStarted', 'Validating')} />
              </div>
            </div>
          )}
          <div className='form-border'>
            <FormRow>
              <h1 className='font-header-light text-5xl mt-4 mb-0 px-0'>
                {getValue('GetStarted', 'Title')}
              </h1>
              <hr className='more-fein-separator ms-1'></hr>
            </FormRow>
            <FormRow>
              <Label required>{getValue('GetStarted', 'PolicyLabel')}</Label>
              <small className='text-xs p-0 mb-2'>
                {getValue('GetStarted', 'PolicyDesc')}
              </small>
              <NumericInput
                inputId='policyNumber'
                inputValue={policy}
                placeholderText='9999999999'
                letterSpacing={true}
                isInvalid={policyNumRequired}
                errorMessage={getValue('GetStarted', 'ValPolicy')}
                onChange={(e) => NumbersOnly(e.target.value)}
                onBlur={POblur}
                onFocus={POfocus}
              />
            </FormRow>

            <FormRow>
              <Label required>
                {getValue('GetStarted', 'EmailLabelPrefix')}
                <i>{getValue('GetStarted', 'EmailLabelSuffix')}</i>
              </Label>
              <small className='text-xs p-0 mb-2'>
                {getValue('GetStarted', 'EmailDesc')}
              </small>
              <TextInput
                inputId='Email'
                inputValue={email}
                isInvalid={emailRequired}
                errorMessage={getValue('GetStarted', 'ValEmail')}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={EmailBlur}
                onFocus={EmailFocus}
              />
            </FormRow>
            <FormRow>
              <Checkbox
                checkboxId='certified'
                isChecked={certified}
                onChange={handleChangeCertified}
                labelMessage={getValue('GetStarted', 'CertifyAuthorized')}
                isInvalid={!certReq && !certified}
                errorMessage={getValue('GetStarted', 'ValCertify')}
                required={true}
              />
              <Checkbox
                checkboxId='haveClaim'
                isChecked={haveClaim}
                onChange={handleChangeClaim}
                labelMessage={getValue('GetStarted', 'HaveClaim')}
              />
            </FormRow>
            <div className='base-row'>
              <hr className='line-style' />
            </div>

            <ValidationError
              className='errorMessage'
              isInvalid={dataFail}
              message={
                <>
                  {getValue('GetStarted', 'ValNoMatchPrefix')}
                  <i>{getValue('GetStarted', 'ValNoMatchMiddle')}</i>
                  {getValue('GetStarted', 'ValNoMatchSuffix')}
                </>
              }
            />

            <ButtonGroup>
              <span className='col-md-6 mt-2 mb-4' />
              <span className='col-md-6 mt-2 mb-4'>
                <Button
                  bootstrap='col-12'
                  version={IsDataValid() ? 'primary' : 'disabled'}
                  onClick={GoNext}
                >
                  {getValue('GetStarted', 'NextButton')}
                </Button>
              </span>
            </ButtonGroup>
            <div className='base-page'></div>
          </div>
        </div>
      )}
    </>
  );
};

export default GetStarted;
